import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { changeTheme } from "./utils";

// 主题色

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const admin = localStorage.getItem("admin");
changeTheme(admin);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})